module.exports = __webpack_public_path__ + "img/vertical_7_3_8017.c5e48ffe.png";